import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "./Contact.css";

export default class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
      loading: false,
      status: "",
      message: "",
    };

    this.recaptchaRef = React.createRef();
  }

  handleCaptchaChange = (value) => {
    this.setState({
      captcha: value,
      status: "",
      message: "",
    });
  };

  handleCaptchaExpired = () => {
    this.setState({
      captcha: null,
      status: "error",
      message: "אימות האבטחה פג. יש לאשר שוב שאינכם רובוטים.",
    });
  };

  resetCaptcha = () => {
    this.setState({ captcha: null });

    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };

  sendEmail = async (e) => {
    e.preventDefault();

    if (this.state.loading) return;

    const form = e.currentTarget;
    const formData = new FormData(form);

    const name = String(formData.get("name") || "").trim();
    const phone = String(formData.get("phone") || "").trim();
    const message = String(formData.get("message") || "").trim();

    const normalizedPhone = phone.replace(/\D/g, "");

    if (!name || !phone || !message) {
      this.setState({
        status: "error",
        message: "נא למלא את כל השדות.",
      });
      return;
    }

    if (!/^0\d{8,9}$/.test(normalizedPhone)) {
      this.setState({
        status: "error",
        message: "נא להזין מספר טלפון ישראלי תקין.",
      });
      return;
    }

    if (!this.state.captcha) {
      this.setState({
        status: "error",
        message: "נא להשלים את אימות האבטחה לפני שליחת ההודעה.",
      });
      return;
    }

    this.setState({
      loading: true,
      status: "",
      message: "",
    });

    try {
      await emailjs.sendForm(
        "service_vegf8ui",
        "template_br2e9eh",
        form,
        "user_7XjWzaNdKiGR2BG0wBiLt"
      );

      form.reset();
      this.resetCaptcha();

      this.setState({
        loading: false,
        status: "success",
        message: "ההודעה נשלחה בהצלחה! נחזור אליכם בהקדם.",
      });
    } catch (error) {
      console.error("EmailJS sending error:", error);

      this.resetCaptcha();

      this.setState({
        loading: false,
        status: "error",
        message: "שליחת ההודעה נכשלה. נסו שוב בעוד מספר רגעים.",
      });
    }
  };

  render() {
    const { loading, status, message } = this.state;

    return (
      <section
        className="contact-page"
        aria-labelledby="contact-title"
      >
        <Container>
          <div className="contact-content">
<div className="contact-heading">
  <span className="contact-eyebrow">
    הדרך לעסק שלך מתחילה כאן
  </span>

  <h2 id="contact-title">
    העסק שלך מתחיל ברישוי נכון
  </h2>

  <p>
    צריכים רישיון עסק, היתר לשימוש חורג או ליווי בתהליך הרישוי?
    השאירו פרטים ונחזור אליכם כדי לבחון את הצרכים שלכם
    ולקדם את העסק בדרך הנכונה
  </p>
</div>

            <div className="contact-card">
              <div className="contact-card-heading">
                <h3>השאירו פרטים ונחזור אליכם</h3>
                <p>מלאו את הפרטים וניצור אתכם קשר בהקדם.</p>
              </div>

              <form
                className="contact-form"
                onSubmit={this.sendEmail}
                noValidate
              >
                <div className="contact-field">
                  <label htmlFor="contact-name">
                    שם מלא
                  </label>

                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    placeholder="איך קוראים לכם?"
                    autoComplete="name"
                    maxLength={80}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="contact-phone">
                    מספר טלפון
                  </label>

                  <input
                    id="contact-phone"
                    type="tel"
                    name="phone"
                    placeholder="לדוגמה: 0501234567"
                    autoComplete="tel"
                    inputMode="tel"
                    maxLength={16}
                    required
                    disabled={loading}
                    aria-describedby="contact-phone-help"
                  />

                  <span
                    id="contact-phone-help"
                    className="contact-field-help"
                  >
                    יש להזין מספר טלפון ישראלי.
                  </span>
                </div>

                <div className="contact-field">
                  <label htmlFor="contact-message">
                    במה נוכל לעזור?
                  </label>

                  <textarea
                    id="contact-message"
                    name="message"
                    placeholder="כתבו לנו ונשמח לעזור..."
                    rows="5"
                    maxLength={1500}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="contact-captcha">
                  <ReCAPTCHA
                    ref={this.recaptchaRef}
                    sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                    onChange={this.handleCaptchaChange}
                    onExpired={this.handleCaptchaExpired}
                    hl="iw"
                  />
                </div>

                {message && (
                  <div
                    className={`contact-feedback ${
                      status === "success"
                        ? "contact-feedback-success"
                        : "contact-feedback-error"
                    }`}
                    role={status === "success" ? "status" : "alert"}
                    aria-live="polite"
                  >
                    {message}
                  </div>
                )}

                <button
                  type="submit"
                  className="contact-submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="contact-spinner"
                        aria-hidden="true"
                      />
                      שולח הודעה...
                    </>
                  ) : (
                    "שליחת הודעה"
                  )}
                </button>

                <p className="contact-privacy">
                  הפרטים שתמסרו ישמשו לצורך חזרה אליכם בלבד.
                </p>
              </form>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}